// @ts-nocheck

import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import GRBasketSwitch from '../components/GRBasketSwitch';
import selectGRBasketSwitchProps from '../selectors/specifics/selectGRBasketSwitchProps';

type GRBasketSwitchContainerProps = {
  className?: string;
  oddsId?: number;
};

const GRBasketSwitchContainer = ({ oddsId, ...ownProps }: GRBasketSwitchContainerProps) => {
  const dispatch = useDispatch();

  const selectorProps = useMemo(() => ({ oddsId, dispatch }), [dispatch, oddsId]);
  const { isVisible, basketMode, ...selectedProps } = useSelector((state) =>
    selectGRBasketSwitchProps(state, selectorProps),
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  // Important to retrigger autoToggleOnRender (due to rerendering) when basketMode changes
  const key = useMemo(() => {
    let result = 'gr-basket-switch';

    if (oddsId) {
      result += `-${oddsId}`;
    }

    if (basketMode) {
      result += `-${basketMode}`;
    }

    return result;
  }, [oddsId, basketMode]);

  return isVisible ? <GRBasketSwitch {...enhancedProps} key={key} /> : null;
};

export default GRBasketSwitchContainer;
